import type { IModalProgressConfig, TypeBuildReturn } from './types';

import { create } from './create';

// ----------------------------------------------------------------------------

class ProgressManager {
    getElement(): HTMLElement | null {
        return document.querySelector<HTMLElement>('#modal-progress');
    }

    getProgressBar(): HTMLElement | null {
        return document.querySelector<HTMLElement>('#modal-progress .progress-bar');
    }

    // ------------------------------------------------------------------------

    start(config: IModalProgressConfig = {}): TypeBuildReturn | undefined {
        const elModalProgress = this.getElement();

        if (elModalProgress) {
            return;
        }

        return create({
            merge: config,
        });
    }

    stop(): void {
        const elModalProgress = this.getElement();

        if (!elModalProgress) {
            return;
        }

        elModalProgress.hideModal();
    }

    update(value: number | string): void {
        const elProgressBar = this.getProgressBar();

        if (!elProgressBar) {
            return;
        }

        const parsedValue = typeof value === 'number' ? value : Number(value);
        const outputValue = Number.isNaN(parsedValue) ? String(value) : `${parsedValue}%`;

        elProgressBar.style.width = outputValue;
        elProgressBar.innerHTML = outputValue;
    }
}

// ----------------------------------------------------------------------------

export default ProgressManager;
